import {useQuery} from "@tanstack/react-query";
import {readRevenueTableSetting} from "../../../../../api/main/SalesApi";

export const useReadRevenueTableSetting = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueTableSetting"],
        queryFn: async () => await readRevenueTableSetting(),
        select: (res) => res?.data.result ?? {revenueViewInfoVOList: []},
    });

    return {data};
};
